import { hexToRgb } from '../../../../utils/functions';

export default ({
  palette: { text },
  fonts,
  spacing,
  breakpoints: { down },
}) => ({
  form: {
    marginTop: spacing(12),
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 3,
    transitionDelay: ({ formIsSent }) =>
      formIsSent ? '0s' : '0.2s',
    transition: 'opacity .3s',
    opacity: ({ formIsSent }) => (formIsSent ? 0 : 1),
    [down('xs')]: {
      marginTop: spacing(7),
    },
  },
  formField: {
    marginTop: spacing(9),
    [down('xs')]: {
      marginTop: spacing(7),
    },
    '& .MuiInputBase-multiline': {
      paddingBottom: spacing(0),
    },
    '& input': {
      height: 50,
      maxHeight: 50,
      padding: spacing(0),
      [down('xs')]: {
        height: 40,
        maxHeight: 40,
      },
    },
    '& input, textarea': {
      fontSize: fonts.size.xxxm,
      fontWeight: 400,
      lineHeight: '50px',
      [down('sm')]: {
        fontSize: fonts.size.xm,
        lineHeight: '40px',
      },
      [down('xs')]: {
        fontSize: fonts.size.s,
        lineHeight: '40px',
      },
      [down(365)]: {
        fontSize: fonts.size.xs,
      },
      [down(325)]: {
        fontSize: fonts.size.xxs,
      },
    },
    '& textarea': {
      backgroundImage: `linear-gradient(transparent, transparent 49px, rgba(${
        hexToRgb(text.primary)[0]
      }, ${hexToRgb(text.primary)[1]}, ${
        hexToRgb(text.primary)[2]
      }, 0.2) 0px)`,
      backgroundSize: '100% 50px',
      [down('xs')]: {
        backgroundImage: `linear-gradient(transparent, transparent 39px, rgba(${
          hexToRgb(text.primary)[0]
        }, ${hexToRgb(text.primary)[1]}, ${
          hexToRgb(text.primary)[2]
        }, 0.2) 0px)`,
        backgroundSize: '100% 40px',
      },
    },
    '& .MuiInput-underline:after': {
      borderBottom: `2px solid ${text.primary}`,
    },
    '& label': {
      fontSize: fonts.size.xs,
      color: text.secondary,
      opacity: 0.5,
      fontWeight: 400,
    },
    '& label.Mui-focused': {
      color: text.primary,
      opacity: 0.5,
    },
    '&:first-child': {
      marginTop: spacing(0),
    },
    '& .MuiInputBase-input:-webkit-autofill, .MuiInputBase-input:-webkit-autofill:hover, .MuiInputBase-input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus': {
      transition: 'background-color 5000s ease-in-out 0s',
    },
  },
  emptyFormField: {
    '& label': {
      fontSize: fonts.size.xxxm,
      color: text.primary,
      opacity: 0.9,
      fontWeight: 300,
      [down('sm')]: {
        fontSize: fonts.size.xm,
      },
      [down('xs')]: {
        fontSize: fonts.size.s,
      },
      [down(365)]: {
        fontSize: fonts.size.xs,
      },
      [down(325)]: {
        fontSize: fonts.size.xxs,
      },
    },
    '& label.Mui-focused': {
      fontSize: fonts.size.xs,
      opacity: 0.5,
      fontWeight: 400,
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: text.primary,
    },
  },
});
